import React from "react";
import CreatableSelect from "react-select/creatable";

const MultipleCreatableSearch = ({
  name,
  value,
  onChange,
  labelClass,
  inputClass,
  errorClass,
  error,
  label,
  isRequired,
  options,
  isMulti,
  onInputChange,
  placeholder,
}) => {
  return (
    <>
      {label && (
        <label htmlFor={name} className={`c-label ${labelClass}`}>
          {label} {isRequired && <span className="asterisk f-12">&#42;</span>}
        </label>
      )}
      <div className={`position-relative`}>
        <CreatableSelect
          className={`${inputClass} ${error ? "error" : ""}`}
          isMulti={isMulti}
          classNamePrefix="select"
          isSearchable={true}
          options={options}
          name={name}
          createOptionPosition="first"
          value={value}
          onChange={onChange}
          onInputChange={onInputChange}
          placeholder={placeholder}
        />
      </div>
      {error && <div className={`invalid ${errorClass}`}>{error}</div>}
    </>
  );
};

export default MultipleCreatableSearch;
